import { vsComponentName as roleDetailUsersComponentName } from "./component";
import {
  RoleDetailTabsServiceProvider,
  vsProviderName as RoleDetailTabsServiceProviderName,
} from "../service";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import {
  GridConfiguration,
  vsComponentName as recordGridViewComponentName,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../../../records/views/recordGridView";
import { vsObjectName as userObjectName } from "../../../config/user";
import { RecordDataSource } from "../../../../records/grids";
import { Role, RoleUser } from "../../../model/authorityGroup";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../../records/grids/settings/gridSettingsService";
import { vsComponentName as editComponentName } from "./edit";

roleDetailUsersComponentConfig.$inject = [RoleDetailTabsServiceProviderName];
export function roleDetailUsersComponentConfig(
  roleDetailTabsServiceProvider: RoleDetailTabsServiceProvider
) {
  roleDetailTabsServiceProvider.addElement({
    displayName: "Users",
    id: "users",
    uiSrefFragment: "users",
    requiredPermission: "userModify",
    stateDefinition: {
      url: "/users",
      component: roleDetailUsersComponentName,
      resolve: {
        gridConfiguration: [
          "role",
          RecordGridViewServiceName,
          ServerUtilityName,
          GridSettingsServiceName,
          (
            role: Role,
            recordGridViewService: RecordGridViewService,
            serverUtility: ServerUtility,
            gridSettingsService: GridSettingsService
          ) => {
            const configuration =
              recordGridViewService.getGridConfiguration(userObjectName)!;
            configuration.gridDataSource = new RecordDataSource(
              serverUtility,
              `/api/role/${role.Id}/users`
            );

            configuration.gridSettings = gridSettingsService.getGridSettings(
              Symbol(`${roleDetailTabsServiceProvider.basePath}.users`)
            );

            return configuration;
          },
        ],
      },
    },
    children: [
      {
        id: "edit",
        displayName: "Edit",
        uiSrefFragment: "edit",
        stateDefinition: {
          url: "/edit",
          component: editComponentName,
          resolve: {
            gridConfiguration: [
              RecordGridViewServiceName,
              GridSettingsServiceName,
              (
                recordGridViewService: RecordGridViewService,
                gridSettingsService: GridSettingsService
              ) => {
                const configuration =
                  recordGridViewService.getGridConfiguration(userObjectName)!;
                configuration.gridSettings =
                  gridSettingsService.getGridSettings(
                    Symbol(
                      `${roleDetailTabsServiceProvider.basePath}.users.edit`
                    )
                  );
                return configuration;
              },
            ],
            roleUsers: [
              "role",
              ServerUtilityName,
              (role: Role, serverUtility: ServerUtility) =>
                serverUtility.fetchAll<RoleUser>({
                  url: `/api/role/${role.Id}/users`,
                  query: {},
                }),
            ],
          },
        },
      },
    ],
  });
}
